import type { ReactNode } from 'react'

/*
  Modal — diálogo centrado con backdrop. Envuelve `.modal-overlay` > `.modal`
  (+ `.modal-header`, `.modal-body`, `.modal-footer`, `.modal-close`) de index.css.
  Click en el backdrop o en la × cierra; click dentro no se propaga.
*/
interface ModalProps {
  open: boolean
  onClose: () => void
  title?: ReactNode
  children: ReactNode
  footer?: ReactNode
  width?: number | string
}

export function Modal({ open, onClose, title, children, footer, width = 560 }: ModalProps) {
  if (!open) return null
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: width }} onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className="modal-header">
            <h3>{title}</h3>
            <button className="modal-close" onClick={onClose} aria-label="Cerrar">×</button>
          </div>
        )}
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  )
}
